import clsx from 'clsx';
import { domAnimation, LazyMotion, m } from 'framer-motion';

import { DataTestIds } from '@repo/frontend-shared';
import { SDSSkeleton } from '@repo/sds/_internal/SDSSkeleton';

import './LinearProgressBar.scss';

interface LinearProgressBarProps {
  completed: number;
  total: number;
  progressBarClassName?: string;
  progressBarSliderClassName?: string;
  dataTestId?: string;
  isLoading?: boolean;
}

export function LinearProgressBar({
  completed,
  total,
  progressBarClassName,
  progressBarSliderClassName,
  dataTestId,
  isLoading,
}: LinearProgressBarProps) {
  const percentage = total > 0 ? Math.min(100, Math.max(0, (completed / total) * 100)) : 0;

  const combinedProgressBarClassName = clsx('LinearProgressBar', progressBarClassName);

  const combinedProgressBarSliderClassName = clsx('LinearProgressBar__slider', progressBarSliderClassName);

  if (isLoading) {
    return <SDSSkeleton width="100%" height="10px" />;
  }

  return (
    <LazyMotion features={domAnimation}>
      <div className={combinedProgressBarClassName}>
        <m.div
          data-testid={dataTestId ?? DataTestIds.COMMON.PROGRESS_BAR}
          data-progress={percentage}
          className={combinedProgressBarSliderClassName}
          initial={false}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.5 }}
        />
      </div>
    </LazyMotion>
  );
}
